/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const errorSummaryCodesItemCountMax = 9007199254740991

export const errorSummaryLast24hMin = 0
export const errorSummaryLast24hMax = 9007199254740991

export const errorSummaryLast7dMin = 0
export const errorSummaryLast7dMax = 9007199254740991

export const ErrorSummary = zod.object({
  codes: zod.array(
    zod.object({
      code: zod.string(),
      count: zod.int().min(1).max(errorSummaryCodesItemCountMax),
    }),
  ),
  last24h: zod.int().min(errorSummaryLast24hMin).max(errorSummaryLast24hMax),
  last7d: zod.int().min(errorSummaryLast7dMin).max(errorSummaryLast7dMax),
})

export type ErrorSummary = zod.input<typeof ErrorSummary>
export type ErrorSummaryOutput = zod.output<typeof ErrorSummary>
